import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regular-approved-attendance',
  templateUrl: './regular-approved-attendance.component.html',
  styleUrls: ['./regular-approved-attendance.component.css']
})
export class RegularApprovedAttendanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
